<template>
  <div class="w-full h-full p-4">
    <div class="w-full h-full flex flex-col items-center justify-center">
      <img :src="ErrorIllustration" alt="Error illustration" />
      <p class="mt-4 text-center">
        {{ $i18nPresenter.t('Your Slide Sidekick needs a moment.') }}
      </p>
      <p class="mt-1 text-center">
        {{ $i18nPresenter.t('Try a quick refresh or use AhaSlides on Chat GPT instead.') }}
      </p>
      <div class="flex gap-2 mt-4">
        <aha-antd-button
          variant="secondary"
          @click="refresh"
          name="ai-chatbot-iframe-error-refresh"
          v-aha-emit-action
        >
          {{ $i18nPresenter.t('Refresh') }}
        </aha-antd-button>
        <aha-antd-button
          v-if="isAhaSlidesGPTEnabled"
          class="use-aha-gpt-button"
          variant="primary"
          @click="onUseAhaSlidesGPTButtonClicked"
          name="ai-chatbot-iframe-error-use-aha-gpt"
          v-aha-emit-action
        >
          <span>{{ $i18nPresenter.t('Use AhaSlides GPT') }}</span>
          <aha-icon name="arrow-square-out" />
        </aha-antd-button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import ErrorIllustration from '@/assets/images/aha-ai/ErrorIllustration.svg'
import utils from '@/util'

export default {
  data() {
    return {
      ErrorIllustration,
    }
  },

  computed: {
    ...mapGetters('ahaGpt', ['isAhaSlidesGPTEnabled', 'ahaGPTUrl']),
  },

  created() {
    utils.preloadImage({ url: ErrorIllustration })
  },

  methods: {
    refresh() {
      this.$emit('refresh')
    },

    onUseAhaSlidesGPTButtonClicked() {
      window.open(this.ahaGPTUrl, '_blank', 'noopener,noreferrer')
    },
  },
}
</script>

<style lang="scss" scoped>
.use-aha-gpt-button {
  &:deep(.--content-container) {
    @apply flex items-center justify-center gap-1.5;
  }
}
</style>
